import { Component, OnInit, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UserWellsService } from '../user-wells.service';
import { InjectionDataRecord } from '../_models/injection-data-record';
import { InjectionPressureDataRecord } from '../_models/injection-pressure-data-record';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort, Sort, SortDirection } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { WellDetailsModel } from '../_models/well-details-model';
import { InjectionService } from '../_services/injection.service';
import { MatDialog } from '@angular/material/dialog';
import { InjectionRecordEditorComponent } from '../injection-record-editor/injection-record-editor.component';
import { Subscription } from 'rxjs';
import { NgDynamicBreadcrumbService } from 'ng-dynamic-breadcrumb';
import { ExportManagerService } from '../_services/export-manager.service';
import { ExportInjectionPressureManagerService } from '../_services/export-injection-pressure-manager.service';
import { ExportOption } from '../_models/export-option';
import { ExportRequest } from '../_models/export-request';
import { ExportDateRangeSelectorComponent } from '../export-date-range-selector/export-date-range-selector.component';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { MessageDialogComponent } from '../message-dialog/message-dialog.component';
import { EditFormationsDialogComponent } from '../edit-formations-dialog/edit-formations-dialog.component';
import { WellDetailsDisplayComponent } from '../well-details-display/well-details-display.component';
import { DeleteInjectionDialogComponent } from '../delete-injection-dialog/delete-injection-dialog.component';
import { DeleteDateRangeModel } from '../_models/delete-date-range-model';
import { BHPService } from '../_services/bhp.service';

@Component({
  selector: 'app-well-details',
  templateUrl: './well-details.component.html',
  styleUrls: ['./well-details.component.css']
})
export class WellDetailsComponent implements OnInit, AfterViewInit, OnDestroy {

  public wellId: number;
  public wellDetails: WellDetailsModel;
  public injectionDataSource: MatTableDataSource<InjectionDataRecord>;
  public bhpDataSource: MatTableDataSource<any>;

  public detailsWellSubscription: Subscription;
  public currentInjectionsSubscription: Subscription;
  public currentInjectionPressuresSubscription: Subscription;

  public years: Array<number>;
  public year: number;

  public monthly: string = "monthly";

  public minYear = 2015;
  public maxYear = 2021;

  public injectionDisplayedColumns: string[] = ['edit', 'InjectionDate', 'InjectionPressureAveragePsig', 'InjectionPressureMaxPsig', 'VolumeInjectedBbl', 'TotalGasVolumeMcf', 'AnnulusPressureNumReadings', 'AnnulusPressureMinPsig', 'AnnulusPressureMaxPsig', 'MaxDayInjLiqRate', 'DateRowAdded'];
  public bhpDisplayedColumns: string[] = ['edit', 'MeasurementDate', 'ShutinBHPDaily', 'ShutinBHPQuarterlyCalc', 'ShutinBHPQuarterlyMeas', 'TvdDepBHPSensor', 'MeaDayInjLiqDens', 'AveDayMeasBhp', 'MaxDayMeasBhp', 'AveDayEstBhp', 'MaxDayEstBhp', 'ShutinTimeForStaticPress', 'PressureGradient', 'DateRowAdded'];

  @ViewChild(MatSort) injectionSort;
  @ViewChild(MatPaginator) paginator;
  @ViewChild(WellDetailsDisplayComponent) wellDetailsDisplay;

  constructor(private actRoute: ActivatedRoute,
    private userWellsService: UserWellsService,
    private injectionService: InjectionService,
    private bhpService: BHPService,
    private dialog: MatDialog,
    private breadcrumbService: NgDynamicBreadcrumbService,
    public exportManagerService: ExportManagerService,
    public exportInjectionPressureManagerService: ExportInjectionPressureManagerService
  ) {
    this.wellId = this.actRoute.snapshot.params.wellId;

    var now = new Date();

    this.maxYear = now.getFullYear() + 1;
    this.years = new Array<number>();

    for (let i = this.maxYear; i >= this.minYear; i--) {
      this.years.push(i);
    }

    let initInjectionRecords = new Array<InjectionDataRecord>();
    let initBHPRecords = new Array<any>();

    this.injectionDataSource = new MatTableDataSource<InjectionDataRecord>(initInjectionRecords);
    this.bhpDataSource = new MatTableDataSource<any>(initBHPRecords);
  }

  ngOnInit(): void {
    this.detailsWellSubscription = this.userWellsService.detailsWell.subscribe((newDetailsWell: WellDetailsModel) => {
      this.wellDetails = newDetailsWell;

      this.year = new Date().getFullYear();
      this.monthly = "monthly";

      this.refreshInjectionRecords();
      this.refreshInjectionPressureRecords();

      var breadcrumbdata = {
        Uicnumber: this.wellDetails.Uicnumber.toString()
      };

      this.breadcrumbService.updateBreadcrumbLabels(breadcrumbdata);
    });

    this.userWellsService.LoadDetailsWell(this.wellId);
  }

  ngAfterViewInit(): void {
    this.injectionDataSource.paginator = this.paginator;
    this.injectionDataSource.sort = this.injectionSort;
  }

  ngOnDestroy(): void {
    this.detailsWellSubscription.unsubscribe();
    this.injectionService.ClearCurrentRecords();
  }

  handleEditInjectionRowClick(injectionDataRecord: InjectionDataRecord) {
    var dialogRef = this.dialog.open(InjectionRecordEditorComponent, {
      data: {
        injRec: injectionDataRecord
      }
    });
  }

  refreshInjectionRecords(): void {

    if(this.currentInjectionsSubscription == null) {
      this.currentInjectionsSubscription = this.injectionService.currentRecords.subscribe((injectionRecords: Array<InjectionDataRecord>) => {
        if (injectionRecords == null) {
          injectionRecords = new Array<InjectionDataRecord>();
        }

        this.injectionDataSource.data = injectionRecords;
      });
    }

    this.injectionService.GetInjectionData(this.wellId);
  }

  refreshInjectionPressureRecords(): void {

    if(this.currentInjectionPressuresSubscription == null) {
      this.currentInjectionPressuresSubscription = this.bhpService.currentRecords.subscribe((injectionPressureRecords: Array<InjectionDataRecord>) => {
        if (injectionPressureRecords == null) {
          injectionPressureRecords = new Array<InjectionDataRecord>();
        }

        this.bhpDataSource.data = injectionPressureRecords;
      });
    }
    
    this.bhpService.GetInjectionPressureData(this.wellId);
  }

  export(option: ExportOption) {

    var today = new Date();
    var aYearAgo = new Date(today);
    aYearAgo.setFullYear(aYearAgo.getFullYear() - 1);

    //Theoretically, we'd need to 
    var req = new ExportRequest();
    req.BeginYear = null;
    req.BeginMonth = null;
    req.EndYear = null;
    req.EndMonth = null;
    req.WellIds = new Array(this.wellId);
    req.Format = option.Key;

    this.dialog.open(ExportDateRangeSelectorComponent, {
    }).afterClosed().subscribe((result: any) => {

      if (result != undefined) {

        req.BeginYear = result.BeginDate.getFullYear();
        req.BeginMonth = result.BeginDate.getMonth() + 1;
        req.EndYear = result.EndDate.getFullYear();
        req.EndMonth = result.EndDate.getMonth() + 1;

        this.exportManagerService.export(req, true).then((result) => {
          var q = 0;
        },
          (err) => {
            var q = 0;
          });
      }
    });
  }

  exportBHP() {

    var today = new Date();
    var aYearAgo = new Date(today);
    aYearAgo.setFullYear(aYearAgo.getFullYear() - 1);

    //Theoretically, we'd need to 
    var req = new ExportRequest();
    req.BeginYear = null;
    req.BeginMonth = null;
    req.EndYear = null;
    req.EndMonth = null;
    req.WellIds = new Array(this.wellId);
    req.Format = null;

    this.dialog.open(ExportDateRangeSelectorComponent, {
    }).afterClosed().subscribe((result: any) => {

      if (result != undefined) {

        req.BeginYear = result.BeginDate.getFullYear();
        req.BeginMonth = result.BeginDate.getMonth() + 1;
        req.EndYear = result.EndDate.getFullYear();
        req.EndMonth = result.EndDate.getMonth() + 1;

        this.exportInjectionPressureManagerService.export(req, true).then((result) => {
          var q = 0;
        },
          (err) => {
            var q = 0;
          });
      }
    });
  }

  deleteInjectionDateRange() {
    this.dialog.open(DeleteInjectionDialogComponent, {

    }).afterClosed().subscribe((result: any) => {

      var beginDate = result.beginDate;
      var endDate = result.endDate;

      var sBeginDate = beginDate.toLocaleDateString();
      var sEndDate = endDate.toLocaleDateString();

      this.dialog.open(ConfirmDialogComponent, {
        data: {
          title: "Are you sure?",
          message: "You are about to delete the injection data for this well (UIC number " + this.wellDetails.Uicnumber + ") for the period of " + sBeginDate + " through " + sEndDate + ".  This cannot be undone, and you will likely need to resubmit these data.  Are you sure you wish to proceed?"
        }
      }).afterClosed().subscribe((result) => {
        if (result) {

          let deleteRangeArgs = new DeleteDateRangeModel();

          let beginYear = beginDate.getFullYear();
          let beginMonth = beginDate.getMonth() + 1;
          let beginDay = beginDate.getDate();

          let endYear = endDate.getFullYear();
          let endMonth = endDate.getMonth() + 1;
          let endDay = endDate.getDate();

          deleteRangeArgs.beginYear = beginYear;
          deleteRangeArgs.beginMonth = beginMonth;
          deleteRangeArgs.beginDay = beginDay;

          deleteRangeArgs.endYear = endYear;
          deleteRangeArgs.endMonth = endMonth;
          deleteRangeArgs.endDay = endDay;

          deleteRangeArgs.wellId = this.wellDetails.Id;

          this.injectionService.DeleteInjectionDateRange(deleteRangeArgs).then(() => {
            //Refresh the table?

            this.refreshInjectionRecords();
          },
            (err) => {
              this.dialog.open(MessageDialogComponent, {
                data: {
                  title: "Error",
                  message: err
                  }
                });
            });
        }
      });
    })
  }

  deleteInjectionPressureDateRange() {
    this.dialog.open(DeleteInjectionDialogComponent, {
    }).afterClosed().subscribe((result: any) => {

      var beginDate = result.beginDate;
      var endDate = result.endDate;

      var sBeginDate = beginDate.toLocaleDateString();
      var sEndDate = endDate.toLocaleDateString();

      this.dialog.open(ConfirmDialogComponent, {
        data: {
          title: "Are you sure?",
          message: "You are about to delete the injection pressure data for this well (UIC number " + this.wellDetails.Uicnumber + ") for the period of " + sBeginDate + " through " + sEndDate + ".  This cannot be undone, and you will likely need to resubmit these data.  Are you sure you wish to proceed?"
        }
      }).afterClosed().subscribe((result) => {
        if (result) {

          var deleteRangeArgs = new DeleteDateRangeModel();

          let beginYear = beginDate.getFullYear();
          let beginMonth = beginDate.getMonth() + 1;
          let beginDay = beginDate.getDate();

          let endYear = endDate.getFullYear();
          let endMonth = endDate.getMonth() + 1;
          let endDay = endDate.getDate();

          deleteRangeArgs.beginYear = beginYear;
          deleteRangeArgs.beginMonth = beginMonth;
          deleteRangeArgs.beginDay = beginDay;

          deleteRangeArgs.endYear = endYear;
          deleteRangeArgs.endMonth = endMonth;
          deleteRangeArgs.endDay = endDay;

          deleteRangeArgs.wellId = this.wellDetails.Id;

          this.bhpService.DeleteDateRange(deleteRangeArgs).then(() => {
            //Refresh the table?

            this.refreshInjectionPressureRecords();
          },
            (err) => {
              this.dialog.open(MessageDialogComponent, {
                data: {
                  title: "Error",
                  message: err
                  }
                });
            });
        }
      });
    })
  }

  deleteInjectionRecord(record: InjectionDataRecord) {

    var startDateString = new Date(record.InjectionDate).toDateString();
    var endDateString = new Date(record.InjectionEndDate).toDateString();

    this.dialog.open(ConfirmDialogComponent, {
      data: {
        title: "Confirm Deletion",
        message: "Are you sure you wish to delete the injection record for " + startDateString + " through " + endDateString + "?"
      }
    }).afterClosed().subscribe((result) => {
      if (result) {
        this.injectionService.deleteRecord(record).then((result) => {
          var ind = this.injectionDataSource.data.indexOf(record);

          //Remove that record from the displayed data
          this.injectionDataSource.data.splice(ind, 1);
          this.injectionDataSource._updateChangeSubscription(); //Refresh the table
        },
        (err) => {
          this.dialog.open(MessageDialogComponent, {
            data: {
              message: "An error occurred while trying to delete the injection record."
            }
          });
        });
      }
    });
  }

  deleteInjectionPressureRecord(record: InjectionPressureDataRecord) {
    let dateString = new Date(record.MeasurementDate).toDateString();

    this.dialog.open(ConfirmDialogComponent, {
      data: {
        title: "Confirm Deletion",
        message: "Are you sure you wish to delete the injection pressure record for " + dateString + "?"
      }
    }).afterClosed().subscribe((result) => {
      if (result) {
        this.bhpService.deleteRecord(record).then((result) => {
          var ind = this.bhpDataSource.data.indexOf(record);

          //Remove that record from the displayed data
          this.bhpDataSource.data.splice(ind, 1);
          this.bhpDataSource._updateChangeSubscription(); //Refresh the table
        },
        (err) => {
          this.dialog.open(MessageDialogComponent, {
            data: {
              message: "An error occurred while trying to delete the injection pressure record."
            }
          });
        });
      }
    });
  }

  editFormations() {
    this.userWellsService.requestEditFormations(this.wellDetails);
  }
}
